import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion, AccordionTitle, AccordionContent } from '@hpi-sox/hpstellar-core';
import { Specs } from '@hpi-sox/hpstellar-core/TechSpecs/components/Specs';
import Downloads from '@hpi-sox/hpstellar-core/TechSpecs/components/Downloads';

import useDeviceInfo from '../../../hooks/useDeviceInfo';

import './tech-specs-accordion.less';

export default function TechSpecsAccordion({ title = 'Technical details', data, translations, variant, containerId }) {
    const location = useLocation();
    const { isBot } = useDeviceInfo(['isBot']);

    const [open, setOpen] = useState(isBot || location?.hash === `#${containerId}`);
    useEffect(() => {
        setOpen(location?.hash === `#${containerId}` || open);
    }, [location]);

    return (
        <Accordion
            className={`techSpecs-accordion${variant ? ` ${variant}` : ''}`}
            iconType="caret"
            expanded={open}
            onClick={() => setOpen(!open)}
        >
            <AccordionTitle className="techSpecs-accordion-title" expandIconClassName="icon">
                <p className="techSpecs-accordion-text">{title}</p>
            </AccordionTitle>
            <AccordionContent className="techSpecs-accordion-content">
                <Downloads
                    className="techSpecs-accordion-download-links"
                    datasheets={data?.datasheets || []}
                    formatTestHook={() => {}}
                />
                <Specs
                    className="techSpecs-accordion-details"
                    data={{ ...data, datasheets: [] }}
                    translations={translations}
                    theme={variant}
                />
            </AccordionContent>
        </Accordion>
    );
}
